

import LoginMsg from "./common/Loginmsg.vue";
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Alert from 'vux/src/components/alert/index.vue'

import Clipboard from "clipboard";

export default {
name: "Index",
components: {


Swiper,
SwiperItem,
LoginMsg,
Alert,
},
data() {
return {
funList: [
{
title: "参谋指数还原",
key: "sycm",
hint: {
text: "167239人",
back: "#f00",
},
content: [
{
subhead: "",
list: [
"一个账号多店使用。",
"一键转化指数，准确度高达99.99%",
"可查看同类目任意宝贝关键指标。",
"覆盖市场、竞争、品类、流量模块",
"快速查找蓝海词",
"宝贝标题深度分析，操作便捷",
"同价格带爆品分析，透视爆品起爆方式",
"自动计算高阶指标，如客单价、UV价值",
"非爬虫，安全可靠",
],
},
],
},

{
title: "直通车工具",
key: "ztc",
hint: {
text: "82859人",
back: "#f00",
},
content: [
{
subhead: "",
list: [
"批量添加人群，几秒即可添加100个人群",
"一键分析数千个关键图，快速筛选优质词",
"省级、市级城市数据优化，减少低产城市点击",
"批量下载同关键词下的车图",
"时段优化，数据精确到每小时",
],
},
],
},
{
title: "宝贝详情页工具",
key: "bbxq",
hint: {
text: "免费",
back: "#ff7e33",
},
content: [
{
subhead: "",
list: [
"买家秀批量下载",
"评语、问大家一键下载",
"主图、主视频&SKU图下载",
"淘宝客推广透视",
"SKU数据分析",
"评语趋势分析",
"类目、车词、自然搜索词透视",
],
},
],
},
{
title: "店铺动态监控",
key: "dpdt",
hint: {
text: "新品",
back: "#3af",
},
content: [
{
subhead: "",
list: [
"可监控全网任意宝贝",
"实时销量、SKU销量",
"店铺上新动态监控",
"透视宝贝的上新时间、类目、售价、销量、收藏、加购等数据",
"可快速定位转化率高的宝贝",
],
},
],
},
{
title: "京东商智指数还原",
key: "jdsz",
hint: {
text: "免费",
back: "#ff7e33",
},
content: [
{
subhead: "",
list: [
"一键还原指数，准确率99.99%",
"覆盖行业与竞争模块",
"非爬虫、安全可靠",
"自动计算高阶指数，例UV价值、客单价",
],
},
],
},
{
title: "京东详情页工具",
key: "jdxq",
hint: {
text: "新品",
back: "#3af",
},
content: [
{
subhead: "",
list: [
"任意宝贝买家秀、评论下载",
"宝贝主图、主视频、SKU下载",
"任意宝贝SKU销量分析",
"一键详情页下载",
],
},
],
},




















],
videoList: [




































{
title: "京东商智指数还原",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/jdsz.png",
videoUrl: "https://static.diantoushi.com/video/dts_0320_2.mp4",
},
],
showService: false,
serverImg: "https://static.diantoushi.com/cnd/qrcode/dts-qr_003.png",
backTop: "https://static.diantoushi.com/images/20200424/backTop.png",
};
},
methods: {
goPage: function (url) {
this.$router.push(url);
},
handlePlayVideo: function (item, index) {
let video = document.getElementById("video" + index);
video.src = item.videoUrl;
video.play();
},
handleShowService: function () {
this.showService = true;
},
scrollFunction: function () {
let backTopDom = document.getElementById("backTop");
if (backTopDom) {
if (
document.body.scrollTop > 20 ||
document.documentElement.scrollTop > 20
) {
backTopDom.style.display = "block";
} else {
backTopDom.style.display = "none";
}
}
},

handleToTop: function () {
window.scrollTo({
top: 0,
behavior: "smooth",
});
},
goDetail: function (item, index) {
this.$router.push({
name: "MainDetail",
params: { funcItem: item, idx: index },
});
},
goMjtsDetail: function () {
this.$router.push("/blackcheck");
},
closeDialog: function () {
this.showService = false;
},
initCopy: function () {
let self = this;
this.$nextTick(() => {
const copybtn = this.$refs.copy;
let clipboard = new Clipboard(copybtn);
clipboard.on("success", function () {
self.$vux.toast.show({
text: "复制成功，请添加微信好友",
type: 'text',
width: '250px',
})
});

clipboard.on("error", function () {
self.$vux.toast.show({
text: "复制失败",
type: 'text',
width: 'auto',
})
});
});
},
},
mounted() {
this.initCopy();
let that = this;







window.onscroll = function () {
that.scrollFunction();
};
},
};
